<template>
  <hm-content title="" :showExport="!isDetail">
    <div class="relative page">
      <div class="flex">
        <div class="search-left">
          <div class="flex flex-between"><div class="line-title">选择筛选条件</div><el-button v-if="!isDetail" @click="handleEdit({})" size="small" type="primary">新增分类</el-button></div>
          <div class="bg mt20 search-left-height">
            <!-- <div class="openAll mb10 flex flex-end" @click="openAll">
            全部展开
          </div> -->
            <el-collapse v-model="activeNames" :disabled="isDetail" @change="handleChange">
              <el-collapse-item
                :name="v.id"
                v-for="(v, i) in tagAttributeList"
                :key="i"
              >
                <template slot="title">
                  <div class="collapse-title flex item-center">
                    <img class="edit-img" @click.stop="handleEdit(v)" src="@/assets/edit-person-tag.png" alt="" srcset="">
                    {{ v.categoryName
                    }}<span class="num" v-if="v.catNum">{{ v.catNum }}</span>
                  </div>
                </template>
                <div
                  class="collapse-list flex flex-between flex-wrap item-center"
                >
                  <div
                    class="collapse-item"
                    :class="{ 'collapse-item-active': item.checked }"
                    v-for="(item, index) in v.childrenList"
                    :key="index"
                    @click="showTag(v, item)"
                  >
                    {{ item.tagName }}
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="search-right flex-1 ml20">
          <div class="line-title">人群同时满足以下特征</div>
          <div class="bg search-right-height">
            <div class="group-list" v-if="catNumAll">
              <template v-for="(v, i) in tagAttributeList">
                <div class="group-item mt20" :key="i" v-if="v.catNum">
                  <div class="group-title">{{ v.catName }}</div>
                  <template v-for="(o, oindex) in v.childrenList">
                    <div class="tagName" :style="{background: o.tagResultCalcMode==='subtract' ?'rgba(236, 25, 25, 0.04)':'rgba(29, 255, 174, 0.04)'}" :key="oindex" v-if="o.checked">
                      <div
                        class="close el-icon-circle-close"
                        @click="showTag(v, o)"
                      ></div>
                      {{ o.tagName }}
                      <el-select
                        v-model="o.tagResultCalcMode"
                        placeholder="请选择"
                        style="width: 100px"
                        size="mini"
                        class="ml10"
                        :disabled="isDetail"
                      >
                        <el-option
                          v-for="(z, zindex) in tagResultCalcModeList"
                          :key="zindex"
                          :label="z.itemText"
                          :value="z.itemValue"
                        >
                        </el-option>
                      </el-select>
                      <div class="mt10">

                        <el-checkbox-group
                          v-model="o.tagNameListGroup"
                          @change="tagRunInfoListChange(o)"
                          v-if="true"
                          class="flex flex-column flex-wrap"
                          :disabled="isDetail"
                        >

                          <div
                            v-for="(p, pindex) in o.tagDetails.tagRunInfoList"
                            :key="pindex"
                            class="flex item-center mr20 mb20"
                          >
                            <el-checkbox
                              :label="p.id"
                              :disabled="p.requiredQuery === 'yes'"
                            >
                              <span
                                class="fontSpan fontRed"
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.requiredQuery === 'yes'
                                "
                                >*</span
                              >{{ p.tagName }}
                              <div
                                v-if="p.dataDesc"
                                class="fr"
                                style="margin-left: 4px"
                              >
                                <el-popover
                                  trigger="hover"
                                  :content="p.dataDesc"
                                  placement="top-start"
                                >
                                  <i
                                    slot="reference"
                                    class="el-icon-warning-outline"
                                  ></i>
                                </el-popover>
                              </div>
                            </el-checkbox>

                            <div class="ml10 flex">
                              <el-select
                                v-model="p.queryListValue"
                                multiple
                                placeholder="请选择"
                                style="width: 300px"
                                size="mini"
                                class="ml10"
                                v-show="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.associatedDictCode &&
                                    p.selectList.length
                                "
                                :disabled="isDetail"
                              >
                                <el-option
                                  v-for="(k, kindex) in p.selectList"
                                  :key="kindex"
                                  :label="k.itemText"
                                  :value="k.itemValue"
                                >
                                </el-option>
                              </el-select>
                              <div
                                class="tag-input"
                                @click="showDialogVisibleEmp(p)"
                                style="width: auto; min-width: 240px"
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'strings' &&
                                    p.queryMode === 'equal' &&
                                    p.componentCode === 'SCRMSTAFFID'
                                "
                              >
                                <span
                                  class="tag-place"
                                  v-if="
                                    !p.queryUser ||
                                      (p.queryUser && !p.queryUser.length)
                                  "
                                  >请选择</span
                                >
                                <template v-else>
                                  <el-tag
                                    v-for="(unit, unique) in p.queryUser"
                                    :key="unique"
                                    :closable="!isDetail"
                                    @close="handleClose(unit)"
                                    :type="!isDetail?'default':'info'"
                                    >{{ unit.userName }}</el-tag
                                  >
                                </template>
                              </div>
                              <div
                                class="tag-input mr10"
                                @click="showDialogVisibleShop(p)"
                                style="width: auto; min-width: 240px"
                                v-else-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'strings' &&
                                    p.queryMode === 'equal' &&
                                    p.componentCode === 'SCRMCOMPANYID'
                                "
                              >
                                <span
                                  class="tag-place"
                                  v-if="
                                    !p.queryShop ||
                                      (p.queryShop && !p.queryShop.length)
                                  "
                                  >请选择</span
                                >
                                <template v-else>
                                  <el-tag
                                    v-for="(unit, unique) in p.queryShop"
                                    :key="unique"
                                    :closable="!isDetail"
                                    @close="handleCloseShop(unit, p)"
                                    :type="!isDetail?'default':'info'"
                                    >{{ unit.wecomDeptName }}</el-tag
                                  >
                                </template>
                              </div>
                              <el-select
                                v-model="p.queryInputValue"
                                filterable
                                placeholder="请选择"
                                class="mr10"
                                style="width: auto; min-width: 240px"
                                multiple
                                v-else-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'strings' &&
                                    p.queryMode === 'equal' &&
                                    p.componentCode === 'scrm_dkadb_brand_name'
                                "
                                :disabled="isDetail"
                              >
                                <el-option
                                  v-for="item in brandList"
                                  :key="item.brandcode"
                                  :label="item.brandname"
                                  :value="item.brandname"
                                >
                                </el-option>
                              </el-select>
                              <el-cascader
                                v-model="p.queryInputValue"
                                :show-all-levels="false"
                                class="mr10 flex-1"
                                style="100px"
                                :props="categoryFuncs"
                                clearable
                                placeholder="请选择类目"
                                v-else-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'strings' &&
                                    p.queryMode === 'equal' &&
                                    p.componentCode ===
                                      'scrm_dkadb_category_name'
                                "
                              ></el-cascader>
                              <template v-else-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                  p.columnType === 'strings' &&
                                  p.queryMode === 'equal' &&
                                  !p.associatedDictCode
                                ">
                                <!-- <div  v-if="p.columnName.includes('itemcode')"> -->
                                  <div class="input-wrap" v-for="(inputVal, iInd) in p.queryInputValue"
                                      :key="iInd">
                                    <el-input
                                      class="mr10 mb5"
                                      type="text"
                                      v-model.trim="p.queryInputValue[iInd]"
                                      clearable
                                      placeholder="请输入"
                                      size="mini"
                                      :disabled="isDetail"
                                    ></el-input>
                                    <img v-if="!isDetail && p.queryInputValue.length > 1" src="@/assets/del-icon.png" style="width: 18px;" alt="" @click="p.queryInputValue.splice(iInd,1)">
                                  </div>
                                  <el-button v-if="!isDetail" type="primary" size="mini" @click="p.queryInputValue.push('')">添加</el-button>
                                <!-- </div> -->
                                <!-- <el-input
                                  type="text"
                                  v-model.trim="p.queryInputValue"
                                  clearable
                                  placeholder="请输入"
                                  size="mini"
                                  v-else
                                  :disabled="isDetail"
                                ></el-input> -->
                              </template>
                              
                              <span
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'integer' &&
                                    p.queryMode === 'range'
                                "
                              >
                                <el-select v-model="p.rangeMode" :disabled="isDetail" size="mini">
                                  <el-option label="大于" value="gt"></el-option>
                                  <el-option label="大于等于" value="gte"></el-option>
                                  <el-option label="介于" value="between"></el-option>
                                  <el-option label="小于" value="lt"></el-option>
                                  <el-option label="小于等于" value="lte"></el-option>
                                </el-select>
                                <template v-if="p.rangeMode==='between'">
                                  <el-input
                                    type="text"
                                    v-model.trim="p.queryInputStartValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input>
                                  -
                                  <el-input
                                    type="text"
                                    v-model.trim="p.queryInputEndValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input>
                                </template>
                                <template v-if="p.rangeMode === 'gt' || p.rangeMode === 'gte'">
                                  <el-input
                                    type="text"
                                    v-model.trim="p.queryInputStartValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input>
                                </template>
                                <template v-if="p.rangeMode === 'lt' || p.rangeMode === 'lte'">
                                  <el-input
                                    type="text"
                                    v-model.trim="p.queryInputEndValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input>
                                </template>
                                  <!-- <el-input
                                    type="text"
                                    v-model.trim="p.queryInputStartValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input>
                                  -
                                  <el-input
                                    type="text"
                                    v-model.trim="p.queryInputEndValue"
                                    clearable
                                    placeholder="请输入"
                                    size="mini"
                                    :disabled="isDetail"
                                  ></el-input> -->
                              </span>




                              
                              <el-select v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'dateRange'
                                    ||
                                  o.tagNameListGroup.includes(p.id) &&
                                  p.columnType === 'date' &&
                                  p.queryMode === 'range'
                                  ||
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'dateRange'
                                " size="mini"
                                :disabled="isDetail"
                                class="ml10"
                                v-model="p.queryStartEndValueType">
                                <el-option value="A" label="时间段选择"></el-option>
                                <el-option value="B" label="相对时间选择"></el-option>
                              </el-select>

                              <el-date-picker
                                v-model="p.queryStartEndValue"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']"
                                size="mini"
                                class="ml10"
                                :disabled="isDetail"
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'datetime' &&
                                    p.queryMode === 'dateRange' && p.queryStartEndValueType=='A'
                                "
                              >
                              </el-date-picker>
                              <el-date-picker
                                v-model="p.queryStartEndValue"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="mini"
                                class="ml10"
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'dateRange' && p.queryStartEndValueType=='A'
                                "
                                :disabled="isDetail"
                              >
                              </el-date-picker>
                              <span
                                v-if="
                                 (
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'dateRange'
                                    ||
                                  o.tagNameListGroup.includes(p.id) &&
                                  p.columnType === 'date' &&
                                  p.queryMode === 'range'
                                  ||
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'dateRange'
                                 )&& p.queryStartEndValueType=='B'
                                "
                                class="flex"
                              >
                                <el-select
                                  size="mini"
                                  v-model="p.datetimeRangeType"
                                  :disabled="isDetail"
                                >
                                  <el-option
                                    v-for="(v, i) in dateTypeList"
                                    :key="i"
                                    :label="v.itemText"
                                    :value="v.itemValue"
                                  ></el-option>
                                </el-select>
                                <!-- <span class="fontSpan fontRed">*</span> -->
                                <el-input
                                  type="text"
                                  v-model.trim="p.queryInputStartValue"
                                  clearable
                                  placeholder="请输入"
                                  size="mini"
                                  :disabled="isDetail"
                                ></el-input>
                                <!-- <span class="fontSpan">-</span> -->
                                <!-- <span class="fontSpan fontRed">*</span> -->
                                <el-input
                                  type="text"
                                  v-model.trim="p.queryInputEndValue"
                                  clearable
                                  placeholder="请输入"
                                  size="mini"
                                  :disabled="isDetail"
                                ></el-input>
                              </span>
                              
                              <el-date-picker
                                v-model="p.queryStartEndValue"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="mini"
                                v-if="
                                  o.tagNameListGroup.includes(p.id) &&
                                    p.columnType === 'date' &&
                                    p.queryMode === 'range' && p.queryStartEndValueType=='A'
                                "
                                :disabled="isDetail"
                              >
                              </el-date-picker>
                            </div>


                          </div>
                        </el-checkbox-group>

                        
                        <el-select
                          v-model="o.tagNameListGroup"
                          multiple
                          placeholder="请选择"
                          style="width: 300px"
                          v-else
                          :disabled="isDetail"
                        >
                          <el-option
                            v-for="(p, pindex) in o.tagDetails.tagRunInfoList"
                            :key="pindex"
                            :label="p.tagName"
                            :value="p.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <div class="empty flex flex-center item-center" v-else>
              <div class="in">
                <img :src="empty" class="image" />
                <div class="text" v-if="!isDetail">👈左侧点击需要的标签，开始圈选吧～</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="!isDetail">
        <div class="content flex flex-between item-center">
          <div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="flex item-center"
            >
              <el-form-item
                label="人群名称："
                prop="calcName"
                style="margin: 0"
              >
                <el-input
                  type="text"
                  v-model.trim="ruleForm.calcName"
                  clearable
                  placeholder="请输入人群名称"
                  size="small"
                  style="width: 300px"
                  :maxlength="30"
                  :disabled="isDetail"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="人群分类"
                prop="sysCategoryFrontendDisplayId"
                style="margin: 0"
              >
                <el-select
                  v-model="ruleForm.sysCategoryFrontendDisplayId"
                  placeholder="请选择人群分类"
                  :disabled="isDetail"
                >
                  <el-option
                    v-for="item in tagGroupList"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="flex flex-center">
            <div class="flex item-center estimate mr20">
              <div class="ml30 mr20" v-if="estimateNum > -1">
                预估人数： {{ estimateNum }} 人
              </div>
              <div class="ml30 mr20" v-if="estimateNum == -1">
                预估人数： -人
              </div>
              <el-button size="small" @click="estimate">估算</el-button>
            </div>
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >保存人群</el-button
            >
            <div class="mr20"></div>
            <el-button size="small" @click="$router.back(-1)">取消</el-button>
            <div class="mr20"></div>
          </div>
        </div>
      </div>
      <hm-filter-shop
        v-if="dialogVisibleShop"
        selectType="multiple"
        @setMultipleShopInfo="setMultipleShopInfo"
        :visible="dialogVisibleShop"
        @close="dialogVisibleShop = false"
      ></hm-filter-shop>
      <hm-filter-employee
        selectType="multiple"
        v-if="dialogVisibleEmp"
        @setMultipleEmpInfo="setMultipleEmpInfo"
        :visible="dialogVisibleEmp"
        @close="dialogVisibleEmp = false"
      ></hm-filter-employee>
      <el-dialog
        :title="(currentNode.id ? '修改' : '添加') + '分类'"
        :with-header="false"
        :wrapperClosable="false"
        class="create-tag-drawer"
        :visible.sync="addDialogVisible"
        :append-to-body="true"
        width="600px"
      >
        <el-form
          label-width="120px"
          :model="currentNode"
          :rules="rules"
          ref="currentNode"
          @submit.native.prevent
        >
          <el-form-item label="分类名称" prop="categoryName" :rules="[{required: true, message: '请输入分类名称', trigger: 'blur'}]">
            <el-input
              v-model.trim="currentNode.categoryName"
              placeholder="请输入分类名称"
              class="flex-1"
              clearable
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="分类排序" prop="sortNum">
            <el-input
              v-model.trim="currentNode.sortNum"
              placeholder="请输入分类排序"
              class="flex-1"
              clearable
              maxlength="6"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="addTypeSubmit('currentNode')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </hm-content>
</template>
<script>
import { request, server } from "@/utils/request";
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie, arrayUnique2 } from "@/utils/utils";
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
import HmFilterShop from "@/components/HmFilterShop";
import HmFilterEmployee from "@/components/HmFilterEmployee";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: { HmFilterShop, HmFilterEmployee },
  props: {
    selectedMemo: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      queryType: "user",
      activeNames: [],
      ruleForm: {
        calcName: "",
        configDataList: [],
        selectedMemo: "",
        sysCategoryFrontendDisplayId: "",
      },
      tagGroupList: [],
      rules: {
        calcName: [{
          required: true,
          message: "请输入人群名称",
          trigger: "blur",
        },{
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/,
          message: "人群名称只能包含英文、中文和数字",
        }]
      },
      tagAttributeList: [],
      currentPage: 1,
      pageSize: 99,
      searchConditions: {
        tagCat: "",
      },
      tagCat: "",
      currentIndex: -1,
      groupInfo: [],
      configDataList: [],
      estimateNum: -1,
      parentId: "",
      parentId2: "",
      listTemp: [
        {
          value: "1",
          label: "测试一",
        },
        {
          value: "2",
          label: "测试二",
        },
      ],
      dateTypeList: [
        {
          itemText: "过去",
          itemValue: "-",
        },
        {
          itemText: "未来",
          itemValue: "+",
        },
      ],
      pickerOptions0: {
        // disabledDate(time) {
        //   let curDate = new Date().getTime();
        //   // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
        //   let day = 365 * 24 * 3600 * 1000;
        //   let dateRegion = curDate + day;
        //   return (
        //     time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
        //   );
        // },
      },
      checkForm: true,
      checkFormTips: "请输入必填项",
      catNumAll: 0,
      empty: "https://imgcdn.hemiao100.com/hemiaoBase/scrm/empty.png",
      tagResultCalcModeList: [
        {
          itemText: "且",
          itemValue: "intersection",
        },
        {
          itemText: "排除",
          itemValue: "subtract",
        },
      ],
      dialogVisibleShop: false,
      dialogVisibleEmp: false,
      queryShop: [],
      hemiaoShopId: [],
      mopCompanyId: [],
      wecomDeptId: [],
      employeeQyIdType: "erpStaffId",
      queryUser: [],
      userArray: [],
      row: "",
      brandList: [],
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch(
                "dynamicsDataReportTemplateInfoObtainDynamicsDataReport",
                {
                  pubDate: {
                    queryStartValue: moment().format("YYYY-MM-DD"),
                    queryEndValue: moment().format("YYYY-MM-DD"),
                  },
                  templateCode: "ADB_CAT",
                  categoryLevel: {
                    queryListValue: ["0"],
                  },
                }
              )
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = v.name;
                  v.label = v.name;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch(
                "dynamicsDataReportTemplateInfoObtainDynamicsDataReport",
                {
                  pubDate: {
                    queryStartValue: moment().format("YYYY-MM-DD"),
                    queryEndValue: moment().format("YYYY-MM-DD"),
                  },
                  templateCode: "ADB_CAT",
                  categoryLevel: {
                    queryListValue: [level],
                  },
                  parentCategoryId: {
                    queryListValue: [data.id],
                  },
                }
              )
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.name;
                    v.label = v.name;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      currentNode: {},
      addDialogVisible: false,
    };
  },
  created() {
    if (this.$route.query.sysCategoryFrontendDisplayId) {
      this.ruleForm.sysCategoryFrontendDisplayId = this.$route.query.sysCategoryFrontendDisplayId;
    }
  },
  mounted() {
    if (this.isDetail) {
      this.tagAttributeList = this.selectedMemo.tagAttributeList;
      this.tagAttributeList.forEach((v) => {
        this.catNumAll = this.catNumAll + v.catNum;
      });
      this.$nextTick(() => {
        this.activeNames = this.selectedMemo.activeNames;
      });
    } else {
      this.init();
    }
  },
  methods: {

    async init() {
      await this.queryParentId();
      await this.queryAllTag();
      await this.queryParentId2();
      await this.queryTypeTag();
      this.queryBrandList();
    },
    /**
     * @desc 编辑节点
    */
    handleEdit(item) {
      this.currentNode = {...item};
      this.addDialogVisible = true;
    },
    /**
     * @desc 新增/编辑节点弹窗submit
    */
    addTypeSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            level: 1,
            parentId: this.tagAttributeList[0].parentId
          };
          const ruleForm = JSON.parse(JSON.stringify(this.currentNode));
          Object.assign(params, ruleForm);
          let url = "sysCategoryFrontendDisplayInfoAdd";
          if (ruleForm.id) {
            Object.assign(params, { id: ruleForm.id });
            url = "sysCategoryFrontendDisplayInfoUpdateById";
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
            this.queryAllTag()
            this.addDialogVisible = false;
          });
        }
      });
    },
    handleChange(val) {
      if (this.isDetail) {
        return;
      }
      console.log(val);
      val.forEach((v) => {
        this.tagAttributeList.forEach((o, i) => {
          if (v === o.id) {
            if (o.childrenList && !o.childrenList.length) {
              this.tagCat = o.id;
              this.currentIndex = i;
              this.queryList();
            }
          }
        });
      });
    },
    async queryParentId() {
      const { result } = await this.$store.dispatch(
        "sysCategoryFrontendDisplayInfoQueryByName",
        {
          categoryName: "人群筛选器根节点",
        }
      );
      if (result) {
        this.parentId = result.id;
      }
    },
    async queryAllTag() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch(
        "querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId",
        {
          parentId: this.parentId,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagAttributeList = result.records;
      this.catNumAll = 0;
      this.tagAttributeList.forEach((v) => {
        v.catNum = 0;
        v.childrenList = [];
      });
    },
    async queryList() {
      if (this.tagAttributeList[this.currentIndex].isloading) {
        return;
      }
      console.log("tagCat:", this.tagCat);
      const { result } = await this.$store.dispatch(
        "queryTagListBySysCategoryFrontendDisplayId",
        {
          sysCategoryFrontendDisplayId: this.tagCat,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagAttributeList[this.currentIndex].isloading = true;
      this.tagAttributeList[this.currentIndex].childrenList = result;
      this.tagAttributeList[this.currentIndex].childrenList.forEach((v) => {
        v.checked = false;
        v.tagDetails = {};
        v.tagNameListGroup = [];
        v.tagNameListSelect = [];
      });
      this.tagAttributeList = JSON.parse(JSON.stringify(this.tagAttributeList));
    },
    async showTag(row, childrenRow) {
      if (this.isDetail) {
        return;
      }
      console.log("this.tagId:", childrenRow.id);
      childrenRow.checked = !childrenRow.checked;
      childrenRow.tagResultCalcMode = "intersection";
      row.catNum = 0;
      row.childrenList.forEach((v) => {
        if (v.checked) {
          row.catNum++;
        }
      });
      if (childrenRow.checked) {
        childrenRow.tagNameListGroup = [];
        let url = "";
        if (
          childrenRow.ruleType === "multiColumns" ||
          childrenRow.ruleType === "customDsl"
        ) {
          url = "queryTagBasicInfoAndDataColumnConfigListByTagBasicId";
        } else {
          url = "queryTagBasicInfoAndDataRangeConfigListByTagBasicId";
        }
        const { result } = await this.$store.dispatch(url, {
          id: childrenRow.id,
        });
        if (result) {
          if (
            childrenRow.ruleType === "multiColumns" ||
            childrenRow.ruleType === "customDsl"
          ) {
            childrenRow.tagDetails.tagRunInfoList =
              result.tagDataColumnConfigList;
            if (
              childrenRow.tagDetails.tagRunInfoList &&
              childrenRow.tagDetails.tagRunInfoList.length
            ) {
              childrenRow.tagDetails.tagRunInfoList.forEach((v) => {
                v.tagName = v.labelName;
                v.selectList = [];
              });
            }
          } else {
            childrenRow.tagDetails.tagRunInfoList =
              result.tagDataRangeConfigList;
            if (
              childrenRow.tagDetails.tagRunInfoList &&
              childrenRow.tagDetails.tagRunInfoList.length
            ) {
              childrenRow.tagDetails.tagRunInfoList.forEach((v) => {
                v.tagName = v.frontViewName;
              });
            }
          }
        }
        this.tagAttributeList.forEach((v) => {
          if (v.catNum) {
            v.childrenList.forEach((o) => {
              if (o.checked) {
                if (
                  o.tagDetails &&
                  o.tagDetails.tagRunInfoList &&
                  o.tagDetails.tagRunInfoList.length
                ) {
                  o.tagDetails.tagRunInfoList.forEach((p) => {
                    if (p.requiredQuery === "yes") {
                      o.tagNameListGroup.push(p.id);
                    }
                    if (p.columnType === "strings" && p.queryMode === 'equal' && !p.associatedDictCode && !p.componentCode) {
                      p.queryInputValue = ['']
                    }
                    p.queryStartEndValueType = "A"
                  });
                }
              }
            });
          }
        });
        this.tagAttributeList = JSON.parse(
          JSON.stringify(this.tagAttributeList)
        );
      }
      this.catNumAll = 0;
      this.tagAttributeList.forEach((v) => {
        this.catNumAll = this.catNumAll + v.catNum;
      });
      console.log("this.catNumAll:", this.catNumAll);
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.queryGroupInfo();
        if (!this.groupInfo.length) {
          this.$message({
            message: "请选择标签",
            type: "warning",
          });
          return;
        }
        // this.ruleForm.selectedMemo = JSON.stringify(this.groupInfo);
        // 详情回显数据
        const baseSaveInfo = {
          tagAttributeList: this.tagAttributeList,
          activeNames: this.activeNames,
        };
        this.ruleForm.selectedMemo = JSON.stringify(baseSaveInfo);
        this.ruleForm.configDataList = this.configDataList;
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        // return;
        const { code } = await this.$store.dispatch(
          "savePeoplePackage",
          params
        );
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$router.back(-1);
        }
      }
    },
    tagRunInfoListChange(o) {
      if (this.isDetail) {
        return;
      }
      console.log("tagDataIds:", o.tagNameListGroup);
      o.tagNameListGroupList = [];
      o.tagDetails.tagRunInfoList.forEach((k) => {
        o.tagNameListGroup.forEach(async (j) => {
          if (j === k.id) {
            if (k.associatedDictCode) {
              request({
                url: "/sys/common/dict_items?dictCode=" + k.associatedDictCode,
                method: "post",
                data: {},
              }).then((res) => {
                k.selectList = res.result;
              });
            }
            o.tagNameListGroupList.push({
              id: k.id,
              name: k.tagName,
            });
          }
        });
      });
      // o = JSON.parse(JSON.stringify(o));
    },
    getCheckedTag(val) {},
    queryGroupInfo() {
      this.checkFormTips = "请输入必填项";
      this.checkForm = true;
      this.groupInfo = [];
      this.configDataList = [];
      this.tagAttributeList.forEach((v) => {
        if (v.catNum) {
          v.childrenList.forEach((o) => {
            o.calcValueList = [];
            if (
              o.checked &&
              o.tagDetails &&
              o.tagDetails.tagRunInfoList &&
              o.tagDetails.tagRunInfoList.length
            ) {
              o.tagDetails.tagRunInfoList.forEach((j) => {
                j.calcCondition = "";
                if (o.tagNameListGroup.includes(j.id)) {
                  j.calcCondition = j.id;
                  if (j.calcCondition) {
                    j.calcValue = {
                      queryListValue: [j.calcCondition],
                    };
                  }
                  if (j.associatedDictCode && j.selectList.length) {
                    if (j.queryListValue && j.queryListValue.length) {
                      j.calcValue = {
                        queryListValue: j.queryListValue,
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                  }
                  if (
                    j.componentCode === "SCRMSTAFFID" ||
                    j.componentCode === "SCRMCOMPANYID"
                  ) {
                    if (j.queryInputValue && j.queryInputValue.length) {
                      j.calcValue = {
                        queryListValue: j.queryInputValue,
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                  } else if (j.componentCode === "scrm_dkadb_category_name") {
                    if (j.queryInputValue && j.queryInputValue.length) {
                      let categoryName = this.isArray(j.queryInputValue)
                        ? j.queryInputValue[j.queryInputValue.length - 1]
                        : j.queryInputValue;
                      j.calcValue = {
                        queryListValue: categoryName,
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                  } else if (
                    j.columnType === "strings" &&
                    j.queryMode === "equal" &&
                    !j.associatedDictCode
                  ) {
                    if (j.queryInputValue) {
                      j.calcValue = {
                        queryListValue: Array.isArray(j.queryInputValue)
                          ? j.queryInputValue
                          : [j.queryInputValue],
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                  }
                  if (j.columnType === "integer" && j.queryMode === "range") {
                    // if (j.labelName === "商品件数") {
                    if (
                      (["gt", "gte"].includes(j.rangeMode) &&
                        j.queryInputStartValue) ||
                      (j.rangeMode === "between" &&
                        j.queryInputStartValue &&
                        j.queryInputEndValue) ||
                      (["lt", "lte"].includes(j.rangeMode) &&
                        j.queryInputEndValue)
                    ) {
                      j.calcValue = {
                        queryStartValue: j.queryInputStartValue,
                        queryEndValue: j.queryInputEndValue,
                        rangeMode: j.rangeMode
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                    // } else {
                    //   if (j.queryInputStartValue && j.queryInputEndValue) {
                    //     j.calcValue = {
                    //       queryStartValue: j.queryInputStartValue,
                    //       queryEndValue: j.queryInputEndValue,
                    //     };
                    //   } else {
                    //     this.checkFormTips = j.tagName + ",请输入必填项";
                    //     this.checkForm = false;
                    //   }
                    // }
                  }
                  
                  if (
                    ((j.columnType === "date" || j.columnType === "datetime") &&
                    j.queryMode === "dateRange" || (j.columnType === "date" && j.queryMode === "range")) && j.queryStartEndValueType == "A"
                  ) {
                    if (j.queryStartEndValue && j.queryStartEndValue.length) {
                      j.calcValue = {
                        queryStartValue: j.queryStartEndValue[0],
                        queryEndValue: j.queryStartEndValue[1],
                      };
                    } else {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                  }
                  if (((j.columnType === "date" || j.columnType === "datetime") &&
                    j.queryMode === "dateRange" ||(j.columnType === "date" && j.queryMode === "range")) && j.queryStartEndValueType == "B") {
                    if (!j.queryInputEndValue || !j.queryInputStartValue) {
                      this.checkFormTips = j.tagName + ",请输入必填项";
                      this.checkForm = false;
                    }
                    if (j.datetimeRangeLimit) {
                      if (
                        parseInt(j.queryInputEndValue) -
                          parseInt(j.queryInputStartValue) >
                        parseInt(j.datetimeRangeLimit)
                      ) {
                        this.checkFormTips =
                          j.tagName +
                          ",两个值相差最大为" +
                          j.datetimeRangeLimit;
                      }
                    }
                    if (j.datetimeRangeType === "-") {
                      j.calcValue = {
                        queryStartValue:
                          j.datetimeRangeType + j.queryInputEndValue,
                        queryEndValue:
                          j.datetimeRangeType + j.queryInputStartValue,
                      };
                    } else {
                      j.calcValue = {
                        queryStartValue:
                          j.datetimeRangeType + j.queryInputStartValue,
                        queryEndValue:
                          j.datetimeRangeType + j.queryInputEndValue,
                      };
                    }
                  }
                  o.calcValueList.push({
                    id: j.id,
                    name: j.tagName,
                    calcValue: j.calcValue,
                  });
                }
                this.configDataList.push({
                  calcCondition: j.calcCondition,
                  tagDataId: j.id,
                  columnConfigId: o.id,
                  tagId: o.id,
                  ruleType: o.ruleType,
                  calcValue: JSON.stringify(j.calcValue),
                  tagResultCalcMode: o.tagResultCalcMode,
                });
              });
            }
            if (o.checked && o.tagNameListGroup && o.tagNameListGroup.length) {
              this.groupInfo.push({
                categoryId: v.id,
                categoryName: v.categoryName,
                columnConfigId: o.id,
                tagId: o.id,
                tagName: o.tagName,
                calcValueList: o.calcValueList,
                tagResultCalcMode: o.tagResultCalcMode,
                // calcValue: o.tagNameListGroup,
              });
            }
          });
        }
      });
      console.log("this.groupInfo:", this.groupInfo);
    },
    async estimate() {
      if (this.isDetail) {
        return;
      }
      this.queryGroupInfo();
      // return;
      if (!this.groupInfo.length) {
        this.$message({
          message: "请选择标签",
          type: "warning",
        });
        return;
      }
      if (!this.checkForm) {
        this.$message({
          message: this.checkFormTips,
          type: "warning",
        });
        return;
      }
      this.ruleForm.selectedMemo = JSON.stringify(this.groupInfo);
      this.ruleForm.configDataList = this.configDataList;
      const params = JSON.parse(JSON.stringify(this.ruleForm));
      // return;
      const { code, result } = await this.$store.dispatch(
        "estimatePeoplePackage",
        params
      );
      if (code === "0") {
        this.estimateNum = result.estimateNum;
      }
    },
    async queryParentId2() {
      const { result } = await this.$store.dispatch(
        "sysCategoryFrontendDisplayInfoQueryByName",
        {
          categoryName: "人群包根节点",
        }
      );
      if (result) {
        this.parentId2 = result.id;
      }
    },
    async queryTypeTag() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch(
        "querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId",
        {
          parentId: this.parentId2,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagGroupList = result.records;
    },
    showDialogVisibleShop(row) {
      if (this.isDetail) {
        return;
      }
      this.row = row;
      this.dialogVisibleShop = true;
    },
    setMultipleShopInfo(data) {
      // console.log("data:", data);
      this.queryShop = this.queryShop.concat(data);
      this.queryShop = arrayUnique2(this.queryShop, "mopCompanyId");
      this.hemiaoShopId = [];
      this.mopCompanyId = [];
      this.wecomDeptId = [];
      this.queryShop.forEach((v) => {
        if (v.hemiaoShopId) {
          this.hemiaoShopId.push(v.hemiaoShopId);
        }
        if (v.mopCompanyId) {
          this.mopCompanyId.push(v.mopCompanyId);
        }
        if (v.wecomDeptId) {
          this.wecomDeptId.push(v.wecomDeptId);
        }
      });
      console.log("this.mopCompanyId:", this.mopCompanyId);
      this.row.queryInputValue = this.mopCompanyId;
      this.row.queryShop = this.queryShop;
      this.dialogVisibleShop = false;
    },
    handleCloseShop(tag, p) {
      if (this.isDetail) {
        return;
      }
      const index = this.queryShop.findIndex(
        (item) => item.wecomDeptId === tag.wecomDeptId
      );
      this.queryShop.splice(index, 1);
      this.hemiaoShopId = [];
      this.mopCompanyId = [];
      this.wecomDeptId = [];
      this.queryShop.forEach((v) => {
        if (v.hemiaoShopId) {
          this.hemiaoShopId.push(v.hemiaoShopId);
        }
        if (v.mopCompanyId) {
          this.mopCompanyId.push(v.mopCompanyId);
        }
        if (v.wecomDeptId) {
          this.wecomDeptId.push(v.wecomDeptId);
        }
      });
      this.row.queryInputValue = this.mopCompanyId;
      // this.row.queryShop = this.queryShop;
      p.queryShop = this.queryShop;
      this.tagAttributeList = JSON.parse(JSON.stringify(this.tagAttributeList));
      this.$forceUpdate();
    },
    showDialogVisibleEmp(row) {
      if (this.isDetail) {
        return;
      }
      this.row = row;
      this.dialogVisibleEmp = true;
    },
    setMultipleEmpInfo(data) {
      // console.log("data:", data);
      this.queryUser = this.queryUser.concat(data);
      if (this.employeeQyIdType === "erpStaffId") {
        this.queryUser = arrayUnique2(this.queryUser, "erpStaffId");
        this.userArray = this.queryUser.map((e) => e.erpStaffId);
      } else {
        this.queryUser = arrayUnique2(this.queryUser, "userId");
        this.userArray = this.queryUser.map((e) => e.userId);
      }
      // console.log("this.userArray:", this.userArray);
      this.row.queryInputValue = this.userArray;
      this.row.queryUser = this.queryUser;
      this.dialogVisibleEmp = false;
    },
    handleClose(tag) {
      this.queryUser.splice(this.queryUser.indexOf(tag), 1);
      console.log("this.queryUser:", this.queryUser);
      if (this.employeeQyIdType === "erpStaffId") {
        this.queryUser = arrayUnique2(this.queryUser, "erpStaffId");
        this.userArray = this.queryUser.map((e) => e.erpStaffId);
      } else {
        this.queryUser = arrayUnique2(this.queryUser, "userId");
        this.userArray = this.queryUser.map((e) => e.userId);
      }
      this.row.queryInputValue = this.userArray;
      this.row.queryUser = this.queryUser;
      console.log("this.row.queryUser:", this.row.queryUser);
      this.tagAttributeList = JSON.parse(JSON.stringify(this.tagAttributeList));
    },
    async queryBrandList() {
      const params = {
        pubDate: {
          queryStartValue: moment().format("YYYY-MM-DD"),
          queryEndValue: moment().format("YYYY-MM-DD"),
        },
        templateCode: "ADB_BRAND",
      };
      const { result } = await this.$store.dispatch(
        "dynamicsDataReportTemplateInfoObtainDynamicsDataReport",
        params
      );
      if (result) {
        this.brandList = result;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
  },
};
</script>
<style lang="scss" scoped>
.line-title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 14px;
    background: #E50065;
  }
}
.openAll {
  color: #0081e5;
  cursor: pointer;
}
.search-left {
  width: 360px;
  .bg {
    padding: 20px;
    border-radius: 6px;
    // background: #f7f7f7;
    border: 1px solid #d4d4d4;
  }
  .search-left-height {
    height: 67vh;
    overflow: auto;
  }
  .collapse-title {
    padding-left: 20px;
    position: relative;
    .num {
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: #E50065;
      border-radius: 50%;
      color: #ffffff;
      margin-left: 10px;
      text-align: center;
      display: block;
    }
    .edit-img {
      width: 16px;
      height: 16px;
      position: absolute;
      left: 0;
    }
  }
  .collapse-item {
    width: 140px;
    min-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #dddddd;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #222222;
    margin-top: 10px;
    cursor: pointer;
  }
  .collapse-item-active {
    width: 140px;
    min-height: 32px;
    background: rgba($color: #E50065, $alpha: 0.1);
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #E50065;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #E50065;
  }
}
.search-right {
  .bg {
    border-radius: 6px;
    // background: #f7f7f7;
    // border: 1px solid #d4d4d4;
  }
  .search-right-height {
    height: 67vh;
    overflow: auto;
  }
  .group-list {
    // padding: 20px;
    padding-bottom: 20px;
    .group-item {
      padding: 20px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dddddd;
      .group-title {
        font-weight: bold;
        color: #222222;
      }
      .tagName {
        font-weight: bold;
        color: #222222;
        margin: 0 10px 0 10px;
        position: relative;
        padding: 10px 30px 10px 10px;
        .close {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          opacity: 0;
          cursor: pointer;
        }
      }
      .tagName:hover {
        background: #f7f8fa;
        .close {
          opacity: 1;
        }
      }
    }
  }
  .estimate {
    padding: 20px 0;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  }
}
/deep/ .el-collapse-item__header {
  background: none !important;
}
/deep/ .el-collapse-item__wrap {
  background: none !important;
}
.ml30 {
  margin-left: 30px;
}
.fontSpan {
  font-size: 14px;
  line-height: 24px;
  color: #000000;
  display: inline-block;
  padding: 0 6px;
}
.fontRed {
  color: red;
}
.collapse-list {
  margin: 0 10px;
}
.relative {
  position: relative;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 42px;
  width: 100%;
  height: 90px;
  background: #ffffff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);
  margin: 0 20px;
  z-index: 100;
  .content {
    margin: 0 100px 0 200px;
    height: 90px;
  }
}
.page {
  // padding-bottom: 90px;
}
.empty {
  height: 50vh;
  .in {
    align-self: center;
    .image {
      width: 400px;
      height: 400px;
    }
    .text {
      text-align: center;
      margin-top: -50px;
    }
  }
}
/deep/ .el-collapse {
  border: none !important;
}
// /deep/ .el-collapse-item__header{
//   border: none !important;
// }

.tag-input {
  flex-wrap: wrap;
  height: auto;
  min-height: 40px;
  max-height: 400px;
  overflow-y: auto;
  .el-tag {
    margin: 4px;
  }
}
// .align-center {
//   align-items: center;
// }
.input-wrap {
  display: inline-block;
  position: relative;
  img {
    position: absolute;
    right: 3px;
    top: -10px;
    cursor: pointer;
  }
  .mb5 {
    margin-bottom: 5px;
  }
}
.el-button--mini {
  height: 28px;
}
</style>
